import { Link } from 'react-router-dom';
import { ArrowLeft, Edit3, LockKeyhole, Share2 } from 'lucide-react';
import { Btn } from '../shared';
import { PassportPortrait } from './Primitives';

const positions = { Hitting: 'H', Pitching: 'P', Catcher: 'C', '1st base': '1B', '2nd base': '2B', '3rd base': '3B', Shortstop: 'SS', 'Left field': 'LF', 'Center field': 'CF', 'Right field': 'RF' };
const handedness = { Left: 'L', Right: 'R', Switch: 'S' };

const Hand = ({ value, id }) => <dd data-testid={id}>{value ? <abbr title={value} aria-label={value}>{handedness[value] || value}</abbr> : 'Not added'}</dd>;

export const CompactPlayerHeader = ({ athlete, owner, compact, mediaUrl, onShare, onEdit }) => {
  const [first, ...rest] = athlete.name.trim().split(/\s+/);
  return <div className="pp-phone-header" data-testid="pp-compact-phone-header">
    <header className="pp-header" data-testid="pp-header">
      <div className="pp-heading-copy">
        <p className="eyebrow" data-testid="pp-collection">THE PLAYER COLLECTION</p>
        <h1 className="passport-stone-type" data-testid={compact ? 'pp-opening-title' : 'pp-header-title'}>PLAYER PASSPORT</h1>
        <p className="pp-header-tagline" data-testid="pp-header-tagline">Your journey. Your growth. Your passport.</p>
      </div>
    </header>
    <div className="pp-phone-upper-utilities" data-testid="pp-upper-utilities">
      <span className="pp-lock-label" data-testid="pp-audience"><LockKeyhole size={13} />{owner ? 'Parent view' : 'Invited view'}</span>
      {owner && <Link className="back-link pp-workspace-link" data-testid="pp-workspace-link" to={`/parent/athletes/${athlete.id}`}><ArrowLeft size={13} />Athlete workspace</Link>}
    </div>
    <section className="pp-hero" data-testid="pp-hero">
      <div className="pp-identity-card" data-testid="pp-athlete-identity-card">
        <PassportPortrait src={mediaUrl(athlete.photo_id)} name={athlete.name} id="pp-athlete-photo" large />
        <div className="pp-athlete-identity">
          <p className="pp-player-name passport-stone-type" data-testid="pp-athlete-name" aria-label={athlete.name}><span>{first}{rest.length ? ' ' : ''}</span>{rest.length > 0 && <span>{rest.join(' ')}</span>}</p>
          <p className="pp-sport" data-testid="pp-sport"><span />BASEBALL</p>
          <p className="pp-positions pp-phone-positions" data-testid="pp-positions" aria-label={athlete.positions.join(' · ')}>{athlete.positions.map((position, index) => <span key={`${position}-${index}`}>{index > 0 && <span aria-hidden="true"> · </span>}<abbr title={position} aria-label={position} data-testid={`pp-position-abbreviation-${index}`}>{positions[position] || position}</abbr></span>)}</p>
          <dl className="pp-phone-facts" data-testid="pp-compact-facts">
            <div><dt>Bats:</dt><Hand value={athlete.bats} id="pp-bats" /></div>
            <div><dt>Throws:</dt><Hand value={athlete.throws} id="pp-throws" /></div>
            <div data-testid="pp-hero-age-row"><dt data-testid="pp-age-label">Age:</dt><dd data-testid="pp-age">{athlete.age ?? '—'}</dd></div>
          </dl>
        </div>
      </div>
      <div className="pp-phone-management" data-testid="pp-management-utilities">
        <span className="pp-lock-label pp-managed" data-testid="pp-parent-managed"><LockKeyhole size={12} />Profile managed by parent</span>
        {owner && <button className="pp-text-button" data-testid="pp-edit-baseball-button" onClick={onEdit}><Edit3 size={13} />Edit baseball details</button>}
      </div>
      <div className="pp-hero-aside">
        <p className="pp-mantra" data-testid="pp-mantra">SAME GAME.{' '}<br />BIGGER <span>POTENTIAL.</span></p>
        {owner && <Btn className="pp-primary pp-share-button" data-testid="pp-share-button" onClick={onShare}><Share2 />Share Passport</Btn>}
        <span className="pp-invitation-label" data-testid="pp-invitation-label"><LockKeyhole size={11} />Shared by invitation</span>
      </div>
    </section>
  </div>;
};